
export default class Form {

    static file() {
        const input = document.getElementById('file_project');
        const names = document.getElementById('offerFileInfo');
        const cta = document.getElementById('offerFileCTA');

        // set on init
        if (input) names.innerText = names.dataset.empty;
        if (cta) cta.innerText = cta.dataset.empty;

        // set on change
        if (input && names && cta) {
            input.addEventListener('change', function (e) {
                let fileNames = '';
                if (input.files.length > 0) {
                    for (let j = 0; j < input.files.length; j++) {
                        if ( j === 0) {
                            fileNames = fileNames + input.files[j].name;
                        } else {
                            fileNames = fileNames + ', ' + input.files[j].name;
                        }
                    }
                    names.innerText = fileNames;
                    cta.innerText = cta.dataset.chosen;
                } else {
                    names.innerText = names.dataset.empty;
                    cta.innerText = cta.dataset.empty;
                }
            });
        }
    }
}
